"use strict";
import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import _ from "underscore";
import classNames from "classnames";
import { cleanReferenceValue } from "../helpers/references";
function HoverableValue(props) {
  const [hovered, setHovered] = useState(false);
  const valueEntered = (value2) => {
    if (props.onValueHighlighted) props.onValueHighlighted(value2);
    setHovered(true);
  };
  const valueLeft = () => {
    if (props.onValueHighlighted) props.onValueHighlighted(void 0);
    setHovered(false);
  };
  const valueClicked = (value2) => {
    if (props.onValueClick) props.onValueClick(value2);
  };
  if (_.isEmpty(props.value)) {
    return null;
  }
  const value = cleanReferenceValue(props.value);
  const classes = classNames({
    "hoverable-value-table__value": true,
    "hoverable-value-table__value--selected": hovered
  });
  return /* @__PURE__ */ jsx(
    "span",
    {
      onMouseEnter: () => valueEntered(value),
      onMouseLeave: valueLeft,
      onClick: () => valueClicked(value),
      className: classes,
      children: value
    }
  );
}
export default HoverableValue;
